export default function LogoutIcon({ className }: { className?: string }) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      xmlnsXlink="http://www.w3.org/1999/xlink"
      width="37"
      height="37"
      viewBox="0 0 37 37"
      className={className}
    >
      <defs>
        <clipPath id="logout-path">
          <rect id="Rectangle_690" data-name="Rectangle 690" width="19.748" height="14.707" fill="currentColor" />
        </clipPath>
      </defs>
      <rect id="Rectangle_706" data-name="Rectangle 706" width="37" height="37" rx="18.5" fill="#1e40af"/>
      <g id="Group_1927" data-name="Group 1927" transform="translate(5.5 10.646)">
        <g id="Group_1926" data-name="Group 1926" clipPath="url(#logout-path)">
          <path
            id="Path_1213"
            data-name="Path 1213"
            d="M4.051,92.189H14.406a.894.894,0,1,0,0-1.787H4.051l1.155-1.156a.894.894,0,1,0-1.264-1.264L1.262,90.663c-.021.021-.04.043-.059.065l-.013.017c-.014.017-.027.035-.039.053l-.01.017c-.013.019-.025.038-.035.059l-.006.012c-.011.022-.022.044-.031.067l0,.008c-.01.024-.019.049-.026.074l0,.01c-.007.025-.014.049-.019.075,0,.008,0,.015,0,.023s-.007.042-.009.064A.848.848,0,0,0,1,91.3a.858.858,0,0,0,0,.089c0,.022.006.043.009.064s0,.015,0,.022c.005.026.012.051.019.076l0,.009c.008.025.017.05.026.074l0,.008c.009.023.02.045.032.067l.006.012c.011.02.023.04.035.059l.01.016c.012.018.026.036.039.053l.013.017c.019.022.038.044.059.065l2.681,2.681a.894.894,0,1,0,1.264-1.264Z"
            transform="translate(-0.957 -83.942)"
            fill="currentColor"
          />
          <path
            id="Path_1214"
            data-name="Path 1214"
            d="M3.618,93.956a.93.93,0,0,1-.662-.275L.274,91c-.02-.02-.04-.043-.061-.068L.2,90.919l-.008-.011c-.012-.016-.025-.032-.037-.05l-.007-.012,0-.005C.137,90.824.123,90.8.111,90.78L.1,90.767C.1,90.749.082,90.724.072,90.7l0-.005v0c-.011-.027-.02-.053-.028-.077l0-.007v0c-.008-.028-.015-.054-.02-.079,0,0,0-.01,0-.014V90.5l0-.011c0-.018-.006-.038-.008-.057a.9.9,0,0,1,0-.093.887.887,0,0,1,0-.094c0-.024.006-.047.01-.067v-.009s0-.009,0-.014c.005-.026.012-.051.02-.079l0-.012c.007-.022.016-.047.027-.075l0-.01c.009-.023.021-.046.032-.069l0-.006,0-.007c.012-.023.026-.044.037-.062l0-.006.006-.01c.012-.018.025-.036.042-.057l0,0,.009-.013c.02-.025.041-.047.062-.069l2.681-2.681A.937.937,0,1,1,4.28,88.319L3.2,89.4h10.25a.937.937,0,1,1,0,1.874H3.2L4.28,92.357a.937.937,0,0,1-.662,1.6m0-7.15a.845.845,0,0,0-.6.249L.336,89.736c-.02.02-.038.04-.056.062l-.007.009,0,.006c-.017.021-.028.036-.038.051l0,.006-.005.009c-.011.017-.023.036-.034.056l0,0-.005.01c-.01.019-.02.04-.029.062l0,.008c-.01.026-.018.049-.025.07l0,.009c-.008.026-.014.049-.018.072v.009s0,.009,0,.013-.007.039-.009.06a.8.8,0,0,0,0,.085.808.808,0,0,0,0,.085c0,.017,0,.034.007.052l0,.01,0,.012v.009c0,.023.011.046.018.072l0,.006c.008.025.016.048.026.073l0,.005v0c.009.023.021.046.03.063l.006.013c.01.019.022.038.033.055l0,.008,0,.008c.01.015.021.03.033.045l.01.013.007.01c.019.023.037.043.056.061L3.016,93.62a.851.851,0,1,0,1.2-1.2L2.99,91.189H13.449a.851.851,0,1,0,0-1.7H2.99l1.229-1.229a.851.851,0,0,0-.6-1.452"
            transform="translate(0 -82.984)"
            fill="currentColor"
          />
          <path
            id="Path_1215"
            data-name="Path 1215"
            d="M149.466,1a7.306,7.306,0,0,0-6.072,3.237.894.894,0,1,0,1.484,1,5.523,5.523,0,1,1,.007,6.164.894.894,0,1,0-1.481,1A7.311,7.311,0,1,0,149.466,1"
            transform="translate(-137.072 -0.957)"
            fill="currentColor"
          />
          <path
            id="Path_1216"
            data-name="Path 1216"
            d="M148.517,14.707a7.351,7.351,0,0,1-6.1-3.242.937.937,0,1,1,1.553-1.049,5.48,5.48,0,1,0-.007-6.116.937.937,0,1,1-1.555-1.045,7.354,7.354,0,1,1,6.107,11.451m-5.323-4.617a.851.851,0,0,0-.7,1.327,7.267,7.267,0,1,0-.01-8.113.851.851,0,1,0,1.412.949,5.566,5.566,0,1,1,.007,6.212.845.845,0,0,0-.543-.359.855.855,0,0,0-.163-.016"
            transform="translate(-136.123)"
            fill="currentColor"
          />
        </g>
      </g>
    </svg>
  );
}